export const localStorageAdapter = {
  get: (key: string): string | null => window.localStorage.getItem(key),
  set: (key: string, data: string): void =>
    window.localStorage.setItem(key, data)
}
